import { render, staticRenderFns } from "./PrintRecipe.vue?vue&type=template&id=0c1fa7f7"
import script from "./PrintRecipe.vue?vue&type=script&lang=js"
export * from "./PrintRecipe.vue?vue&type=script&lang=js"
import style0 from "./PrintRecipe.vue?vue&type=style&index=0&id=0c1fa7f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports